<template>
  <div>
    <div class="login-container">
      <!--    <LogoIcon class="logo-icon" />-->
      <span class="title">Search for an artist (or paste Spotify URL)</span>
      <div class="login-content">
        <div class="inputs">
          <div class="floating-label has-icon">
            <input v-model="searchInput" @input="handleSearchInput"
              placeholder="Search by artist name (or paste a Spotify URL)" type="text" name="spotify" id="spotify"
              autocomplete="off" />
            <label for="spotify">
              Search by artist name
            </label>
            <div class="input-icon">
              <SpotifyIcon class="icon small" />
            </div>
          </div>
        </div>

        <div v-if="searching" class="searching">
          Searching...
        </div>

        <div v-else class="artists">
          <div v-for="artist in artists" :key="artist.id" class="artist" @click="getMeta(artist.id)">
            <template v-if="artist.images.length">
              <div class="artist-image" v-bind:style="{
                backgroundImage: 'url(' + artist.images[0].url + ')'
              }"></div>
            </template>
            <template v-else>
              <div class="artist-image missing"></div>
            </template>

            <div class="name">{{ artist.name }}</div>
            <div class="followers">
              Followers: {{ artist.followers.total.toLocaleString() }}
            </div>
          </div>
          <button
            class="button-secondary plausible-event-name=No+Spotify"
            @click="notOnSpotifyModal = true"
          >
            <span>My music isn't on Spotify</span>
          </button>
        </div>
      </div>
    </div>
    <div v-if="notOnSpotifyModal" class="modal">
      <div class="background-overlay"></div>
      <div class="modal-container">
        <div @click="notOnSpotifyModal = false" class="modal-close">
          
          <CloseIcon />
        </div>
        <div class="modal-content">
          <template>
            <label class="default-input">
              <span class="wheres-music"> What's the artist's name? </span>
              <input
                v-model="artistName"
                placeholder="Artist Name"
                type="text"
                name="artist_name"
                id="artist_name"
                autocomplete="off"
              />
            </label>
            <button
              @click="addArtist(artistName)"
              class="button-default big"
              :disabled="!artistName"
            >
              <span>Submit</span>
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import LogoIcon from "../../../public/img/icons/logo.svg";
import SpotifyIcon from "../../../public/img/icons/spotify.svg";
import CloseIcon from "../../../public/img/icons/close.svg";
import { Q_META, Q_SEARCH_ARTISTS, Q_GET_LONGER_URL } from "@/graphql";
export default {
  name: "AddArtistWizardStepAddArtist",
  components: {
    // LogoIcon,
    SpotifyIcon,
    CloseIcon,
  },
  data() {
    return {
      searching: false,
      searchInput: null,
      sourceLoaded: false,
      sourceLoading: false,
      artists: [],
      notOnSpotifyModal: false,
      artistName: ""
    };
  },
  async created() {
    this.$store.commit("addArtist/resetArtists");
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  },
  methods: {
    handleSearchInput() {
      if (!this.searchInput) {
        clearTimeout(this.timeout);
        this.searching = false;
        this.artists = [];
        return;
      }

      this.searching = true;


      if (this.searchInput.indexOf("spotify.link") !== -1) {
        this.resolveSpotifyLink(this.searchInput)
          .then(async (longUrl) => {
            console.log('longy', longUrl);
            this.getSpotifyID(longUrl).then(spotify_id => {
              if (spotify_id) {
                this.getMeta(spotify_id);
              } else {
                this.searching = false;
              }
            });
          })
          .catch(err => console.error(err));
      }
      else if (this.searchInput.indexOf("open.spotify.com/artist") !== -1) {
        this.getSpotifyID(this.searchInput).then(spotify_id => {
          if (spotify_id) {
            this.getMeta(spotify_id);
          } else {
            this.searching = false;
          }
        });
      } else {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.searchSpotify(), 1000);
      }
    },
    async searchSpotify() {
      console.log("Search term:", this.searchInput);
      const artists = await this.$apollo
        .query({
          query: Q_SEARCH_ARTISTS,
          variables: {
            name: this.searchInput
          }
        })
        .then(response => JSON.parse(response.data.search_artists.data));

      this.searching = false;
      this.artists = artists;
    },
    async getSpotifyID(spotify_link) {
      if (spotify_link.indexOf("open.spotify.com/artist") === -1) {
        await this.$store.dispatch("snack", {
          type: "error",
          text: "Oops! This doesn't look like a Spotify artist link."
        });
        return;
      }
      return spotify_link
        .split("?")[0]
        .replace("https://open.spotify.com/artist/", "")
        .replace("http://open.spotify.com/artist/", "");
    },
    async getSpotifyIDOfShortUrl(spotify_link) {
      return spotify_link
        .split("?")[0]
        .replace("https://spotify.app.link/", "")
        .replace("http://spotify.app.link/", "");
    },
    async getMeta(spotify_id) {
      const duplicate = this.user.artists.filter(
        artist => artist.spotify_id === spotify_id
      );
      if (duplicate.length) {
        await this.$store.dispatch("snack", {
          type: "error",
          text: "Oops! You already have this artist added to your account."
        });
        this.spotify_link = null;
        return;
      }
      const metaUrl = "http://open.spotify.com/artist/" + spotify_id;
      await this.$store.dispatch("snack", {
        text: "Loading metadata, please wait...",
        autoDismiss: false
      });
      const result = await this.$apollo.query({
        query: Q_META,
        variables: {
          url: metaUrl
        }
      });
      this.$store.commit("resetSnack");
      const metaData = JSON.parse(result.data.meta.data);
      this.$store.commit("addArtist/addArtist", {
        spotify_id: spotify_id,
        name: metaData["og_title"],
        avatar_url: metaData["og_image"]
      });
      this.sourceLoaded = true;
      this.next();
    },
    async resolveSpotifyLink(shortUrl) {
      console.log(shortUrl);
      const url = await this.$apollo
        .query({
          query: Q_GET_LONGER_URL,
          client: "localClient",
          variables: {
            link: shortUrl
          }
        })
        .then(response => response.data.get_long_spotify_url_from_shortened.preview_url);


      return url;
    },
    addArtist(name) {
      this.$store.commit("addArtist/addArtist", { name });
      this.next();
    },
    next() {
      this.$emit("nextStep");
    }
  }
};
</script>

<style lang="scss" scoped>
.artists {
  display: grid;
  grid-template-columns: repeat(1, 460px);

  .artist {
    padding: 10px;
    border: 1px solid #100e2a;
    border-radius: 10px;
    margin-bottom: 20px;
    width: 100%;
    margin-bottom: 20px auto;
    background: #100e2a;

    &:hover {
      background: #000;
      border: 1px solid $purple;
      cursor: pointer;
    }

    .artist-image {
      background-size: cover;
      float: left;
      height: 80px;
      width: 80px;
      border-radius: 50%;
      margin: 0 20px 0 10px;

      &.missing {
        background-color: #000;
        border: 1px solid #fff;

        &::before {
          content: "?";
          font-size: 30px;
          padding: 25px;
          display: block;
          line-height: 30px;
          text-align: center;
        }
      }
    }

    .name {
      font-size: 20px;
      padding-top: 15px;
    }

    .followers {
      padding-top: 10px;
    }
  }
}

.login-container {
  width: 100%;
  height: 100%;
  /* BG/type2 */
  //background: $bg-type-2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .logo-icon {
    width: 54px;
  }

  .title {
    display: block;
    margin-top: 30px;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
    margin-right: 30px;
    margin-left: 30px;
    text-align: center;
  }

  .login-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
    margin-top: 30px;

    .inputs {
      display: grid;
      grid-template-columns: repeat(1, 460px);
      margin-bottom: 20px;
    }

    button.continue {
      margin-top: 18px;
      width: 276px;
    }
  }
}

.modal {
  position: fixed;
  top: 0;
  left: calc(222px + 6vw);
  width: calc(100% - 222px - 6vw);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  .modal-container {
    padding: 60px 0 0;
    width: 450px;
    z-index: 98;
    background: linear-gradient(
      241.25deg,
      rgba(41, 39, 85, 0.45) 4.4%,
      rgba(41, 39, 84, 0.85) 61.77%,
      rgba(27, 24, 66, 0.45) 119.94%
    );
    backdrop-filter: blur(23px);
    border-radius: 10px;
    .modal-close {
      cursor: pointer;
      position: absolute;
      top: 18px;
      right: 18px;
      display: flex;
      flex-direction: column;
      &:hover {
        svg {
          path {
            fill: white;
          }
        }
        .close-text {
          color: white;
        }
      }
      svg {
        width: 24px;
        path {
          fill: #8786ab;
        }
      }
    }
    .modal-content {
      display: flex;
      flex-direction: column;
      padding: 0 40px 30px;
      .wheres-music {
        margin-bottom: 10px;
        color: #ffffff;
        padding-left: 5px;
        font-size: 14px;
      }
      button {
        margin-top: 10px;
      }
      .thank-you {
        margin: 20px 0;
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        color: #ffffff;
        text-align: center;
      }
    }
  }
  .background-overlay {
    z-index: 97;
    position: fixed;
    top: 0;
    left: calc(222px + 6vw);
    width: calc(100% - 222px - 6vw);
    height: 100%;
    cursor: unset;
    /* Purple-dark */
    background: $purple-dark;
    opacity: 0.9;
    // webkit-backdrop-filter: blur(10px) !important;
    backdrop-filter: blur(10px) !important;
  }
  @media screen and (max-width: 1024px){
      .background-overlay{
        left: auto;
        right: auto;
        float: none;
        width: 300vh;
      }
    }
  @media screen and (max-width: 1024px){
      .modal-container{
       margin-left: -140px;
       margin-right: 100px;
      }
    }
  
}

</style>
